import cloudbase from '@cloudbase/app'
import { registerAuth } from '@cloudbase/auth'
import { registerFunctions } from '@cloudbase/functions'
import { registerStorage } from '@cloudbase/storage'
import { registerRealtime } from '@cloudbase/realtime'
import { registerModel } from '@cloudbase/model'
import { registerAi } from '@cloudbase/ai'
import { registerCloudrun } from '@cloudbase/cloudrun'
import { registerMySQL } from '@cloudbase/mysql'
import { registerApis } from '@cloudbase/apis'
// @ts-ignore
import { registerDatabase } from '../database/src/index'
import { ICloudbase } from '@cloudbase/types'

// __SDK_VERSION__ will be replaced at build time
declare  const __SDK_VERSION__: string
const version: string = __SDK_VERSION__
cloudbase.registerVersion(version)

try {
  registerAuth(cloudbase)
  registerFunctions(cloudbase)
  registerStorage(cloudbase)
  registerDatabase(cloudbase)
  registerRealtime(cloudbase)
  registerModel(cloudbase)
  registerAi(cloudbase)
  registerCloudrun(cloudbase)
  registerMySQL(cloudbase)
  registerApis(cloudbase)
} catch (e) {}

declare global {
  interface Window {
    cloudbase: ICloudbase
  }
}
try {
  (window as Window).cloudbase = cloudbase
} catch (e) {}
// @ts-ignore
export = cloudbase
export default cloudbase
